import { useState } from 'react';

/**
 * 폼 필드를 순서대로 안내하는 훅 (데스크톱 LabeledField 강조 표시용).
 *
 * @param {string[]} fieldOrder - 필드 키 배열. 예: ['departure', 'destination', 'dateTime', 'people']
 *
 * - 현재 안내 중인 필드를 오렌지 강조 표시
 * - 해당 필드에 값이 입력되면 다음 필드로 진행
 * - 순서 밖의 필드에 포커스가 오면 안내 취소
 */
export function useFieldGuide(fieldOrder = []) {
  const [activeKey, setActiveKey] = useState(fieldOrder[0] ?? null);

  const isHighlighted = (key) => activeKey === key;

  const onFocusField = (key) => {
    if (activeKey !== null && key !== activeKey) {
      setActiveKey(null);
    }
  };

  const wrapChange = (key, setter) => (val, ...rest) => {
    setter(val, ...rest);
    if (key === activeKey && val !== '' && val !== null && val !== undefined) {
      const idx = fieldOrder.indexOf(key);
      const next = idx >= 0 && idx + 1 < fieldOrder.length ? fieldOrder[idx + 1] : null;
      setActiveKey(next);
    }
  };

  const resetGuide = () => setActiveKey(fieldOrder[0] ?? null);

  return { isHighlighted, onFocusField, wrapChange, resetGuide };
}
